export const CountyData = {
  barbour: {
    isGreen: true,
    staff: "Ian Tallman",
    blurb:
      "Young Life has been in Barbour County since the early 2000s and has been on and off since its beginning. It began again in the fall of 2023 and is active at Philip Barbour High and Kasson Middle. There are two other middle schools, Philippi and Belington, that we hope to start WyldLife in the years to come.",
    annualBudget: "$68,000",
    imageLocation: "staff-pictures/barbour.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1lJlgrEbBprNk2RtRQPcgZ_Rz0635ADrG/view?usp=sharing",
    givingLink: "https://giving.younglife.org/barbour49plan",
    email: "iantallman14@gmail.com",
    phone: "330-840-4831",
  },
  berkeley: {
    isGreen: true,
    staff: "Kevin Seelinger",
    blurb:
      "For 22 years, Kevin Seelinger and his team have served in Berkeley County. While Young Life, WyldLife, Capernaum, and YoungLives have been serving kids here for a long time, we hope to expand to the southern end of the county with a full-time hire in the fall of 2025.",
    annualBudget: "$177,000",
    imageLocation: "staff-pictures/berkeley.jpg",
    caseStatementLink: "",
    givingLink: "https://giving.younglife.org/epyl",
    email: "younglife99@gmail.com ",
    phone: "304-284-2643",
  },
  boone: {
    isGreen: true,
    staff: "Amber Ferrell",
    blurb:
      "Young Life has had a volunteer leader presence in Boone County for nearly 7 years, with a dedicated staff person starting in 2022. The ministry includes Young Life at Scott High School as well as WyldLife at Madison Middle School.",
    annualBudget: "$24,500",
    imageLocation: "staff-pictures/boone.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1bHhXWu9hrrStgAHKm3n4p5v6dm7_wclk/view",
    givingLink: "https://giving.younglife.org/boone49plan",
    email: "amberferrellyl@gmail.com",
    phone: "681-587-9617",
  },
  braxton: {
    isGreen: true,
    staff: "Wes & Taylor Spencer",
    blurb:
      "Young Life started in Braxton County in 2023. Wyldlife is now active at Braxton County Middle School, and Young Life is developing at Braxton County High!",
    annualBudget: "$68,500",
    imageLocation: "staff-pictures/braxton.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1zJakeJrii7MuSrMni2_H7-ECLn8M_5y9/view",
    givingLink: "https://giving.younglife.org/braxton49plan",
    email: "tspencer.wv@gmail.com",
    phone: "304-288-6845",
  },
  brooke: {
    isGreen: false,
  },
  cabell: {
    isGreen: true,
    staff: "Brad Bucklad",
    blurb:
      "Young Life began serving adolescents in Cabell County at Huntington High in 2010.  Since then we've grown across county and state lines, serving schools in Wayne County and across the river in Ohio. We are present in seven of our middle school and high school communities as well as Marshall university, and are committed to reaching all eighteen schools that exist within the greater Huntington area.",
    annualBudget: "$176,000",
    imageLocation: "staff-pictures/cabell.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1OY8cG9rcVqyB4ZdCY1ur5vB1Bpxlk-1R/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/Huntington49Plan",
    email: "bradbucklad@gmail.com",
    phone: "704-682-2330",
  },
  calhoun: {
    isGreen: true,
    staff: "Michael and Sarah Dague",
    blurb:
      "Michael and Sarah started YoungLife in Calhoun County in January 2025.",
    annualBudget: "",
    imageLocation: "",
    caseStatementLink:
      "",
    givingLink: "https://giving.younglife.org/s/calhouncountywv",
    email: "",
    phone: "",
  },
  clay: {
    isGreen: false,
  },
  doddridge: {
    isGreen: true,
    staff: "Wil Bragg",
    blurb:
      "Young Life is new to Doddridge County as of August 2023. The community and kids have responded fast and furiously. Kids have been to Fall Weekend and camp and are meeting weekly with their leaders.",
    annualBudget: "$10,460",
    imageLocation: "staff-pictures/doddridge.jpg",
    caseStatementLink: "",
    givingLink: "https://giving.younglife.org/doddridge49plan",
    email: "wil.bragg3@gmail.com",
    phone: "304-651-2573",
  },
  fayette: {
    isGreen: true,
    staff: "Kevin Burgess, Megan Weatherford",
    blurb:
      "Young Life in Fayette County is currently providing Clubs, Campaigners (Bible study), Camp, Outreach Events, Service Projects and Leadership Opportunities to students at Oak Hill High School and Oak Hill Middle School. We also have a mentoring program at the New River Ranch Children’s Home and are partnering wtih Megan Weatherford and YoungLives, designed specifically for expecting & parenting teens. Future plans include expanding to Meadow Bridge & Midland Trail & the Gene Spadaro Juvenile Center.",
    annualBudget: "$137,800",
    imageLocation: "staff-pictures/fayette.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/13lYzLVSw_Uuc3pxoqThTZMT-YBZcaaBs/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/fayette49plan",
    email: "kburgess.yl.fayettecounty@gmail.com",
    phone: "540-690-9376",
  },
  gilmer: {
    isGreen: true,
    staff: "Liberty Messer",
    blurb:
      "Young Life is coming to Gilmer County! Our heart is to meet teenagers right where they are, build real relationships, and introduce them to Jesus in a way they can understand. Through showing up in their world, sharing life together, and creating a place where every kid belongs, we hope to make a lasting impact in our community. Your support will help us reach more kids with the Gospel in Gilmer!",
    annualBudget: "",
    imageLocation: "staff-pictures/gilmer.jpg",
    caseStatementLink:
      "",
    givingLink: "https://giving.younglife.org/gilmerco49plan",
    email: "libertynmesser@gmail.com",
    phone: "513-630-0464",
  },
  grant: {
    isGreen: false,
  },
  greenbrier: {
    isGreen: true,
    staff: "Hannah Vogelsong",
    blurb:
      "Greenbrier County Young Life started at Greenbrier West High School 12 years ago. We are now introducing kids to Jesus Christ through Wyld Life and Young Life at all 4 public schools in the county!",
    annualBudget: "$96,500",
    imageLocation: "staff-pictures/greenbrier.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1sGeQTS2p5jQ8ZxWnKzlx8_5g9i5Ijr9F/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/gbc49plan",
    email: "vassh17@gmail.com",
    phone: "304-667-8122",
  },
  hampshire: {
    isGreen: false,
  },
  hancock: {
    isGreen: false,
  },
  hardy: {
    isGreen: false,
  },
  harrison: {
    isGreen: true,
    staff: "Mandy Sharier",
    blurb:
      "Young Life first started in Harrison County in 1998 at Bridgeport HS. We now have Young Life at RCB HS and Bridgeport HS and WyldLife at Lincoln Middle and Bridgeport Middle.",
    annualBudget: "$80,925",
    imageLocation: "staff-pictures/harrison.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1d9RKT6-RnNQ2T5y7Uk2b-9FF150XLxTT/view",
    givingLink: "https://giving.younglife.org/Harrison49Plan",
    email: "mandysharier@gmail.com",
    phone: "330-231-7011",
  },
  jackson: {
    isGreen: true,
    staff: "Volunteer Area",
    blurb:
      "Young Life has been in Jackson County since 2018. We have had a presence with high school and middle school kids in both Ripley and Ravenswood through the work of volunteer leaders. We are looking to raise the funds to hire a part-time staff to help lead our efforts in Jackson County.",
    annualBudget: "",
    imageLocation: "staff-pictures/placeholder.png",
    caseStatementLink: "https://drive.google.com/file/d/1cnvOoDLJ9KZxgovHcc8qMGgoe7yt3KlV/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/jackson49plan",
    email: "bentuel@gmail.com",
    phone: "304-610-0344",
  },
  jefferson: {
    isGreen: true,
    staff: "Kevin Seelinger",
    blurb:
      "For 22 years, Kevin Seelinger and his team have served in Berkeley County. While Young Life, WyldLife, Capernaum, and YoungLives have been serving kids here for a long time, we hope to expand to the southern end of the county with a full-time hire in the fall of 2025.",
    annualBudget: "$177,000",
    imageLocation: "staff-pictures/berkeley.jpg",
    caseStatementLink: "",
    givingLink: "https://giving.younglife.org/epyl",
    email: "younglife99@gmail.com ",
    phone: "304-284-2643",
  },
  kanawha: {
    isGreen: true,
    staff: "Ben Tuel, Sam Scott & Kalissa Fullen",
    blurb:
      "Young started at George Washington High School in 1976. Since then, we've grown to be in 4 high schools, 4 middle schools and at the University of Charleston.",
    annualBudget: "$265,000",
    imageLocation: "staff-pictures/kanawha.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1K0ISXZi-oISkA2K7pDoUEppyd94URIul/view",
    givingLink: "https://giving.younglife.org/KV49plan",
    email: "bentuel@gmail.com",
    phone: "304-610-8757",
  },
  lewis: {
    isGreen: false,
  },
  logan: {
    isGreen: true,
    staff: "Taylor & John Bard",
    blurb:
      "Young Life has been in Logan County since fall of 2020. Currently ministry is active at Logan High School. Leaders have relationships with students at Chapmanville High School and Logan Middle School. Our hope is to start wyldlife at Logan Middle in the 2024-2025 school year.",
    annualBudget: "$88,875",
    imageLocation: "staff-pictures/logan.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1pI1v_GpLiKS438NMrHyWpCABpxdA1d7b/view",
    givingLink: "https://giving.younglife.org/loganmingo49plan",
    email: "Taylormbard@gmail.com",
    phone: "304-669-3108",
  },
  lincoln: {
    isGreen: false,
  },
  marion: {
    isGreen: true,
    staff: "Laurie Paterline",
    blurb:
      "Young Life in Marion County transitioned to full-time staff in the Fall 2020. We have volunteer leaders in all three High Schools and Wyldlife in several Middle Schools.",
    annualBudget: "$94,000",
    imageLocation: "staff-pictures/marion.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/16qBvYsxFk0Sx-iX0N4F7mqWsaFnwFTBX/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/marion49plan",
    email: "lpaterline@gmail.com",
    phone: "304-290-2201",
  },
  marshall: {
    isGreen: true,
    staff: "Sean McCartney & Emily Myers",
    blurb:
      "Ohio Valley Young Life has impacted teenagers in the Ohio Valley for over 50 years! We are committed to reaching every kid and currently have Young Life, WyldLife, YoungLives, and Capernaum in the Ohio Valley! We have Young Life in three High Schools, and WyldLife has five active WyldLife Clubs throughout the Ohio Valley. ",
    annualBudget: "$199,485",
    imageLocation: "staff-pictures/ohio.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1QDvrMpvqLP0YsP3YWb-KxTuCcWVFNVE-/view",
    givingLink: "https://giving.younglife.org/OV49Plan",
    email: "sean.t.mccartney@hotmail.com",
    phone: "412-607-5584",
  },
  mason: {
    isGreen: false,
  },
  mcdowell: {
    isGreen: true,
    staff: "Paul & Faith Dick, Laura Polston",
    blurb:
      "McDowell County Young Life started at River View High School in 2011 with a volunteer-led teacher team.  In 2016 the Dick family came, Paul Dick as Area Director, and since then ministry has expanded to all 5 schools, plus special needs, college and teen parents.  We now have 3 part-time staff covering the county and about 25 volunteer leaders.",
    annualBudget: "$135,600",
    imageLocation: "staff-pictures/mcdowell.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1cpiKngC2Pr0rqU_Mf0BvhBhtOKXZn_kG/view?usp=sharing",
    givingLink: "https://giving.younglife.org/mcdowell49plan",
    email: "paul.g.dick@hotmail.com",
    phone: "724-840-9303",
  },
  mercer: {
    isGreen: true,
    staff: "Logan Brown",
    blurb:
      "Logan has Young Life in Mercer County at Concord University",
    annualBudget: "",
    imageLocation: "staff-pictures/raleigh.jpg",
    caseStatementLink:
      "",
    givingLink: "",
    email: "logandbrown97@gmail.com",
    phone: "304-880-3468",
  },
  mineral: {
    isGreen: true,
    staff: "Gracie Hill",
    blurb:
      "Young Life began in the Potomac Area in 2023. In addition to an established Wyldlife Club at Keyser Middle School, Young Life is now reaching Frankfort High School, Keyser High School, and Potomac State College. YL is also develpoing at Paw Paw Middle and High School. We are praying towards the start of a Wyldlife Club at Frankfort Middle School.",
    annualBudget: "$59,650",
    imageLocation: "staff-pictures/hampshire.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1zJakeJrii7MuSrMni2_H7-ECLn8M_5y9/view",
    givingLink: "https://giving.younglife.org/potomac49plan",
    email: "graciehill508@gmail.com",
    phone: "304-303-4030",
  },
  mingo: {
    isGreen: false,
  },
  monongalia: {
    isGreen: true,
    staff: "Brian Shirak, Marriah Durgin & Zach Beckett",
    blurb:
      "Young Life has been in Monongalia County since 1993 when it started at the high school level. It is now at West Virginia University and in every high school and middle school in the county. Over 60 volunteer leaders are in the Morgantown area who are committed to spreading the Gospel throughout the county.",
    annualBudget: "$223,500",
    imageLocation: "staff-pictures/monongalia.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/17JK1oGde7BJXc5s62sRBar4I0jYZUCZD/view?usp=sharing",
    givingLink: "https://giving.younglife.org/mountaineer49plan",
    email: "brianshirak@outlook.com",
    phone: "304-771-0962",
  },
  monroe: {
    isGreen: true,
    staff: "Caden Phipps",
    blurb:
      "Caden started Young Life at James Monroe High School.",
    annualBudget: "",
    imageLocation: "staff-pictures/monroe.jpg",
    caseStatementLink:
      "",
    givingLink: "",
    email: "cphippswv@gmail.com",
    phone: "304-619-0918",
  },
  morgan: {
    isGreen: true,
    staff: "Gracie Hill",
    blurb:
      "Young Life began in the Potomac Area in 2023. In addition to an established Wyldlife Club at Keyser Middle School, Young Life is now reaching Frankfort High School, Keyser High School, and Potomac State College. YL is also develpoing at Paw Paw Middle and High School. We are praying towards the start of a Wyldlife Club at Frankfort Middle School.",
    annualBudget: "$59,650",
    imageLocation: "staff-pictures/hampshire.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1zJakeJrii7MuSrMni2_H7-ECLn8M_5y9/view",
    givingLink: "https://giving.younglife.org/potomac49plan",
    email: "graciehill508@gmail.com",
    phone: "304-303-4030",
  },
  nicholas: {
    isGreen: true,
    double: true,
    staff: "Marcos Davis (Left), David Moore Jr. (Right)",
    blurb:
      "Young Life has been reaching students in Nicholas County since 2009. Today Young Life ministers to students at both Richwood & Nicholas County High Schools as well as Summersville & Richwood Middle Schools. Marcos is originally from Charlottesville, VA and now serves in Nicholas Co's kids-with-special-needs inclusion program as a Staff Associate.",
    annualBudget: "$100,100",
    imageLocation: "staff-pictures/nicholas.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/11PA-A6OPCkMGh3AWs1nbQT-5QhSx6dLp/view",
    givingLink: "https://giving.younglife.org/nicholas49plan",
    email: "davidmooreyounglife@gmail.com",
    phone: "304-619-6983",
    extraGivingLink: "https://giving.younglife.org/marcosdavis"
  },
  ohio: {
    isGreen: true,
    staff: "Sean McCartney & Emily Myers",
    blurb:
      "Ohio Valley Young Life has impacted teenagers in the Ohio Valley for over 50 years! We are committed to reaching every kid and currently have Young Life, WyldLife, YoungLives, and Capernaum in the Ohio Valley!",
    annualBudget: "$199,485",
    imageLocation: "staff-pictures/ohio.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1QDvrMpvqLP0YsP3YWb-KxTuCcWVFNVE-/view",
    givingLink: "https://giving.younglife.org/OV49Plan",
    email: "sean.t.mccartney@hotmail.com",
    phone: "412-607-5584",
  },
  pendleton: {
    isGreen: false,
  },
  pleasants: {
    isGreen: false,
  },
  pocahontas: {
    isGreen: true,
    staff: "Owen Vogelsong",
    blurb:
      "Young Life started in Pocahontas County in 2014 when local church members wanted to reach students at Marlinton Middle School. Young Life continues to minister to the students of Marlinton Middle School as well as the students of Pocahontas County High School.",
    annualBudget: "$14,000",
    imageLocation: "staff-pictures/pocahontas.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1eVWjlvqG_T6c54QnodDGPjUR1m79mu-k/view",
    givingLink: "https://giving.younglife.org/pocahontas49plan",
    email: "olvogel1@gmail.com",
    phone: "304-667-3243",
  },
  preston: {
    isGreen: true,
    staff: "Lisa Fox",
    blurb:
      "YL started in 2019, and an in-school club continues today at Preston Co HS!",
    annualBudget: "$1,200",
    imageLocation: "staff-pictures/placeholder.png",
    caseStatementLink: "",
    givingLink: "https://giving.younglife.org/preston49plan",
    email: "lisamfox_78@yahoo.com",
    phone: "304-771-1060",
  },
  putnam: {
    isGreen: true,
    staff: "Hunter Sheldon",
    blurb: "",
    annualBudget: "$88,110",
    imageLocation: "staff-pictures/putnam.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1k2OBP6gz1YS9SyNhfsgRROWjNYaQg7Wq/view",
    givingLink: "https://giving.younglife.org/putnam49plan",
    email: "huntersheldon95@gmail.com",
    phone: "304-437-1357",
  },
  raleigh: {
    isGreen: true,
    staff: "Logan Brown & Katey Bogner",
    blurb:
      "Young Life in Raleigh County started in August of 2019 when Logan started ministry at Woodrow Wilson High School. Since then, ministry has expanded to the WVU Tech College Campus, a county WyldLife including Shady Spring, Park, and Beckley-Stratton Middle Schools, and as of 2023, a second high school ministry at Shady Spring High School",
    annualBudget: "$98,800",
    imageLocation: "staff-pictures/raleigh.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1lsfUsFuQjzGHEWZ3LV4g-JkrMgJXtu1z/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/raleigh49plan",
    email: "logandbrown97@gmail.com",
    phone: "304-880-3468",
  },
  randolph: {
    isGreen: true,
    staff: "Brian Hayes & Emma Parlock",
    blurb:
      "YL has been in Randolph County and has been active in Randolph Co since 2010. Young Life is still thriving with Ministry active in Elkins High School and Middle School, Tygart Valley High School and the Middle School developing. Randolph County has specialized ministry in Elkins Capernaum, and Young Life One through Elkins Mountain School.",
    annualBudget: "$120,500",
    imageLocation: "staff-pictures/randolph.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1yAD8Q8n0po9fVdLrYOnLm_yXflL6wWih/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/randolph49plan",
    email: "brianhayes.yl@gmail.com",
    phone: "330-685-0079",
  },
  ritchie: {
    isGreen: false,
  },
  roane: {
    isGreen: false,
  },
  summers: {
    isGreen: false,
  },
  taylor: {
    isGreen: true,
    staff: "Kurtis Davis",
    blurb:
      "YL has been in Taylor County since 2001 when it was started at Grafton High School. YL has been running strong ever since, and recently WyldLife has started at TCMS",
    annualBudget: "$27,200",
    imageLocation: "staff-pictures/taylor.jpg",
    caseStatementLink: "",
    givingLink: "https://giving.younglife.org/taylor49plan",
    email: "kurtis.w.davis@gmail.com",
    phone: "304-613-1985",
  },
  tucker: {
    isGreen: true,
    staff: "Chopper Evans",
    blurb:
      "YL has been in Tucker Co. since 2012 when it started at Tucker Co High School. YL is now active at Tucker Co. High School and developing in the Middle School.",
    annualBudget: "$15,000",
    imageLocation: "staff-pictures/tucker.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1BwpahRj2K47iMjAaWcv9vnjJ6OqdXbWv/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/tucker49plan",
    email: "chopperevans@frontiernet.com",
    phone: "304-642-1234",
  },
  tyler: {
    isGreen: false,
  },
  upshur: {
    isGreen: true,
    staff: "Lauren and Quinn Jeckering",
    blurb: "Young Life has had a presence in Upshur County for many years. In 2025 and onward, Lauren and Quinn prayerfully hope to start Young Life at Buckhannon-Upshur High School.",
    annualBudget: "$19,400",
    imageLocation: "staff-pictures/upshur.jpg",
    caseStatementLink: "https://drive.google.com/file/d/1jgeJZrZ79_fkw9LnbD617zqQnMwKY9uY/view?usp=sharing",
    givingLink: "https://giving.younglife.org/Upshur49Plan",
    email: "lauren.jeckering@gmail.com",
    phone: "304-880-6071",
  },
  webster: {
    isGreen: true,
    staff: "Emmet Rogers",
    blurb:
      "YL has been in Webster Co. since 2010 when it started at Glade Middle. YL is now active at Webster Co. High School.",
    annualBudget: "$26,500",
    imageLocation: "staff-pictures/webster.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1JdAWnvZEY-5ofpE-6qRMGFDNwiv3syjB/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/webster49plan",
    email: "emmetrogers@gmail.com",
    phone: "304-719-3380",
  },
  wetzel: {
    isGreen: true,
    staff: "Alli Childers",
    blurb:
      "There is a long history of Young Life in New Martinsville, WV, but we're currently in a rebuilding phase after going 4 years without it. We currently have Young Life at Magnolia High School and we have prayers and plans to begin Young Life at all of our local schools in Wetzel, Tyler, and Monroe, OH counties",
    annualBudget: "$101,000",
    imageLocation: "staff-pictures/wetzel.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1eTkuGYS3enFb_7xhDj9neqNimNEyCFYl/view",
    givingLink: "https://giving.younglife.org/WTM49Plan",
    email: "allichilders10@gmail.com",
    phone: "304-559-6891",
  },
  wirt: {
    isGreen: false,
  },
  wood: {
    isGreen: true,
    staff: "Kirk Wilson",
    blurb:
      "Young Life began in the Mid-Ohio Valley in 2016 with a teacher at Parkersburg South High School. MOV Young Life is now active at Parkersburg High School, Parkersburg South High School, and has YoungLives.",
    annualBudget: "$141,500",
    imageLocation: "staff-pictures/wood.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1Sqk_6Op-V2JdFwffEehvLSHZDMDRvZ8Q/view",
    givingLink: "https://giving.younglife.org/MOV49Plan",
    email: "kirkwilson99@gmail.com",
    phone: "304-780-6500",
  },
  wyoming: {
    isGreen: false,
  },
  wayne: {
    isGreen: true,
    staff: "Brad Bucklad",
    blurb:
      "Young Life began serving adolescents in Cabell County at Huntington High in 2010.  Since then we've grown across county and state lines, serving schools in Wayne County and across the river in Ohio. We are present in seven of our middle school and high school communities as well as Marshall university, and are committed to reaching all eighteen schools that exist within the greater Huntington area.",
    annualBudget: "$176,000",
    imageLocation: "staff-pictures/cabell.jpg",
    caseStatementLink:
      "https://drive.google.com/file/d/1OY8cG9rcVqyB4ZdCY1ur5vB1Bpxlk-1R/view?usp=drive_link",
    givingLink: "https://giving.younglife.org/Huntington49Plan",
    email: "bradbucklad@gmail.com",
    phone: "704-682-2330",
  },
};
